import React from "react";
import { PulseLoader } from "react-spinners";

interface ButtonProps {
  label: string;
  onClick?: any;
  type?: "button" | "submit" | "reset";
  isLoading?: boolean;
  disabled?: boolean;
  customStyle?: any;
  classNames?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  type = "button",
  isLoading,
  disabled,
  customStyle,
  classNames,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isLoading || disabled}
      className={`${classNames} flex items-center justify-center w-[100%] md:w-[450px] h-[54px] py-2 px-4 rounded-[50px] bg-primary text-white font-medium hover:bg-primaryHover  ease-in-out transition-all $ ${
        isLoading || disabled ? "opacity-50 cursor-not-allowed" : ""
      }`}
      style={customStyle}
    >
      {isLoading ? <PulseLoader color="#fff" size={10} /> : label}
    </button>
  );
};

export default Button;
